export const appAddison = "lDZBQd";
export default {appAddison};